import { Component } from '@angular/core';

@Component({
  selector: 'app-recherche-bien',
  templateUrl: './recherche-bien.component.html',
  styleUrls: ['./recherche-bien.component.scss']
})
export class RechercheBienComponent {
  active = "estimer";
}
